import type { TaskSnapshot } from '../stores/types';

/** Grid column names used for pending-edit bold styling (plus session-only keys like notes). */
export type GanttEditedColumnKey =
  | 'text'
  | 'start_date'
  | 'end_date'
  | 'duration'
  | 'progress'
  | 'taskType'
  | 'locationType'
  | 'predecessors'
  | 'successors'
  | 'notes';

/** Map a store patch onto Gantt grid column names for pending bold styling. */
export function columnKeysFromTaskPatch(
  patch: Partial<TaskSnapshot> | null | undefined,
): GanttEditedColumnKey[] {
  if (!patch) return [];
  const keys: GanttEditedColumnKey[] = [];
  if (patch.taskName !== undefined) keys.push('text');
  if (patch.start !== undefined) keys.push('start_date');
  if (patch.finish !== undefined) keys.push('end_date');
  if (patch.duration !== undefined) keys.push('duration');
  if (patch.percentComplete !== undefined) keys.push('progress');
  if (patch.taskType !== undefined) keys.push('taskType');
  if (patch.locationType !== undefined || patch.locationId !== undefined) {
    keys.push('locationType');
  }
  if (patch.notes !== undefined) keys.push('notes');
  return keys;
}

export function wrapPendingChangeCell(
  isPending: boolean,
  content: string,
): string {
  if (!isPending) return content;
  return `<span class="gantt-cell-pending-change">${content}</span>`;
}
